// client/src/components/tendermaker/BidDetailUploadPage.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { tmBidDocs, tmBidInitUpload, tmBidCommit } from "./tendermakerApi";
import Layout from "../Layout";


export default function BidDetailUploadPage() {
  const { bidId } = useParams();
  const [docs, setDocs] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function refresh() {
    const r = await tmBidDocs(bidId);
    setDocs(r.data || []);
  }

  useEffect(() => {
    refresh().catch((e) => setErr(String(e)));
  }, [bidId]);

  async function uploadMany(fileList) {
    const files = Array.from(fileList || []);
    if (!files.length) return;

    setBusy(true);
    setErr("");
    try {
      for (const f of files) {
        const init = await tmBidInitUpload({
          bidId,
          fileName: f.name,
          contentType: f.type || "application/octet-stream",
        });

        const put = await fetch(init.putUrl, {
          method: "PUT",
          headers: { "Content-Type": f.type || "application/octet-stream" },
          body: f,
        });
        if (!put.ok) throw new Error(`PUT failed: ${put.status}`);

        await tmBidCommit({
          bidId,
          key: init.key,
          fileName: f.name,
          contentType: f.type || null,
        });
      }

      await refresh();
    } catch (e) {
      setErr(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout>
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
      <h2 style={{ marginBottom: 6 }}>TenderMaker — Bid Upload</h2>
      <div style={{ color: "#6b7280", marginBottom: 16 }}>
        bidId: <b>{bidId}</b> • Upload multiple documents (main bid PDF + annexures). Analyzer will treat them as one bid.
      </div>

      {err ? <div style={{ color: "crimson", marginBottom: 12 }}>{err}</div> : null}

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, padding: 12, marginBottom: 16 }}>
        <div style={{ fontWeight: 900, marginBottom: 8 }}>Upload Bid Documents (multiple)</div>
        <input
          type="file"
          multiple
          accept=".pdf,image/*"
          disabled={busy}
          onChange={(e) => uploadMany(e.target.files)}
        />
        {busy ? <div style={{ marginTop: 8 }}>Uploading…</div> : null}
      </div>

      <div style={{ fontWeight: 900, marginBottom: 8 }}>Uploaded docs for this bid</div>
      <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden" }}>
        {docs.map((d) => (
          <div key={d.id} style={{ padding: 12, borderTop: "1px solid #f3f4f6" }}>
            <div style={{ fontWeight: 800 }}>{d.fileName || d.key}</div>
            <div style={{ color: "#6b7280", fontSize: 13 }}>{d.contentType || ""}</div>
          </div>
        ))}
        {docs.length === 0 ? <div style={{ padding: 12, color: "#6b7280" }}>No bid docs uploaded yet.</div> : null}
      </div>
    </div>
    </Layout>
  );
}
